import { type InfiniteData } from '@tanstack/react-query';
import { flatMap } from 'lodash';

import { type ClipsListResponse } from '@air/api';
import { type Clip } from '@air/api/types';

export const formatClipsListResponse = (data: InfiniteData<ClipsListResponse<Clip>> | undefined) => {
  return {
    clips: flatMap(data?.pages, (page) => page.data.clips),
    clipsTotal: data?.pages?.[0]?.data?.total,
  };
};
